import React, { Component } from 'react';
import AppContext from '../contexts/AppContext';
import Contacts from "./ProcessSteps/Contacts";
import Incomes from "./ProcessSteps/Incomes";
import Consent from "./ProcessSteps/Consent";
import WaitingConsent from "./ProcessSteps/WaitingConsent";
import ChooseTerms from "./ProcessSteps/ChooseTerms";
import AML from "./ProcessSteps/AML";
import ViewContract from "./ProcessSteps/ViewContract";
import SignContract from "./ProcessSteps/SignContract";
import Done from "./ProcessSteps/Done";
import ContactsSec from "./ProcessSteps/Spouse/ContactsSec";
import LastKnownStep from "./ProcessSteps/LastKnownStep";
import BadIncomes from "./ErrorPages/BadIncomes";
import CouldNotFinance from "./ErrorPages/CouldNotFinance";
import BasicError from "./ErrorPages/BasicError";
import * as qs from "query-string";
import { withTranslation } from 'react-i18next';
import SpouseMandatory from "./ErrorPages/SpouseMandatory";
import IncomeFamily from "./ProcessSteps/Spouse/IncomeFamily";
import SendSpouseLink from "./ProcessSteps/Spouse/SendSpouseLink";
import ChooseEshopTerms from "./ProcessSteps/Eshop/ChooseEshopTerms";
import {
    ASC_NO_PERSONAL_CODE,
    ASC_NOT_CONFIRMED
} from "../constants";
import {Redirect} from "react-router";
import Loading from "./ProcessSteps/Parts/Loading";

class Process extends Component {

    static contextType = AppContext;

    constructor(props, context) {
        super(props, context);

        const { setProcessStep } = this.context;

        this.state = {
            amount: '',
            type: '',
            term: '',
            application: {},
            loading: true,
            error: null,
            redirect_url: null,
            should_repeat: this.couldNotSignBy1Ct(),
            process_step_urls: {
                'choose_terms': '/' + props.match.params.application_token + '/process/choose_terms',
            },

            is_eshop: null,
            eshop_data: {},
            awaiting_appl_status: false,
            appl_confirmed: false,
            signing_failed_msg: ''
        };

        setProcessStep(this.props.match.params.step);

        this.loadEmoduleData();

        axios.get('/api/process/' + props.match.params.application_token + '/info', {params: {step: props.match.params.step}})
            .then(
                data => {
                    let applicationAmountAndTerm = {
                        amount: 10000,
                        term: 12,
                        type: "IL",
                        loading: false,
                        application: null,
                    };

                    if (data.data.status === 'success') {
                        applicationAmountAndTerm.amount = data.data.data.pref?.amount_total ?? null;
                        applicationAmountAndTerm.term = data.data.data.pref?.term ?? null;
                        applicationAmountAndTerm.type = data.data.data?.product_code || data.data.data?.appl_product || null;
                        applicationAmountAndTerm.application = data.data.data;
                    }

                    this.setState(applicationAmountAndTerm);
                }
            );

        this.processContainerRef = React.createRef();
        this.scrollToProcessContainer = this.scrollToProcessContainer.bind(this);
        this.refreshApplData = this.refreshApplData.bind(this);

        const { awaiting_appl_status } = this.state;
        if ((this.props.match.params.step === 'waiting' && !awaiting_appl_status)
        || (this.props.match.params.step === 'done')){
            this.state.awaiting_appl_status = true;
            this.getApplStatus();
        }
    }

    async getApplStatus()
     {
         await axios.post('/api/process/' + this.props.match.params.application_token + '/get_appl_status').then(
             data => {
                 let result = data.data;
                 this.setState({
                     awaiting_appl_status: result.wait,
                     appl_confirmed: !result.wait,
                     redirect_url: result.redirect_url,
                     signing_failed_msg: result.error_msg ?? ''
                 });

                 if (result.redirect_url === 'waiting' && result.appl_status === ASC_NOT_CONFIRMED) {
                     setTimeout(() => {
                         this.getApplStatus();
                     }, 5000);
                 }
             });
     }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.step !== this.props.match.params.step) {
            const { setProcessStep } = this.context;
            if (this.props.match.params.step === 'done'){
                this.state.awaiting_appl_status = true;
                this.getApplStatus();
            }

            setProcessStep(this.props.match.params.step);
        }
    }

    async refreshApplData() {
        const { application_token, step } = this.props.match.params;
        let response = await axios.get(
            '/api/process/' + application_token + '/info'
            , {params: {step: step}}
        );

        if (response) {
            this.setState({ application: response.data.data });
        }
    }

    loadEmoduleData() {
        const appl_token = this.props.match.params.application_token;

        axios.get('/api/eshop/' + appl_token + '/get_emodule_data')
            .then(
                data => {
                    this.setState({
                        is_eshop: data.data.order_id !== undefined,
                        eshop_data: data.data,
                        process_step_urls: {
                            'choose_terms': data.data.order_id !== undefined ? '/' + appl_token + '/process/choose_eshop_terms' : this.state.process_step_urls.choose_terms,
                        },
                    });
                },
                error => {
                    this.setState({ loading: false });
                }
            )
    }

    couldNotSignBy1Ct() {
        let getParams = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });

        if (getParams.isOK === "Y") {
            return false;
        }

        if (getParams.isOK === "W") {
            return false;
        }

        if (getParams.isOK === "") {
            return false;
        }

        if (getParams.isOK === undefined) {
            return false;
        }

        return true
    }

    getContactData() {
        return {
            first_name: _.get(this.state.application, 'client.ind.first_name', ''),
            last_name: _.get(this.state.application, 'client.ind.last_name', ''),
            email: _.get(this.state.application, 'client.ind.cont.email', ''),
            phone: _.get(this.state.application, 'client.ind.cont.phone', '')
        }
    }

    getContactDataSec() {
        return {
            first_name: _.get(this.state.application, 'client_sec.ind.first_name', ''),
            last_name: _.get(this.state.application, 'client_sec.ind.last_name', ''),
            email: _.get(this.state.application, 'client_sec.ind.cont.email', ''),
            phone: _.get(this.state.application, 'client_sec.ind.cont.phone', ''),
            personal_code: _.get(this.state.application, 'client_sec.ind.subj_code', '')
        }
    }

    scrollToProcessContainer() {
        this.processContainerRef.current.scrollIntoView({ behavior: "smooth" });
    }

    renderErrorPage() {
        switch (this.props.match.params.error_code) {
            case 'SPOUSE_INFO':
                return <SpouseMandatory application_token={this.props.match.params.application_token}/>;
            default:
                return <BasicError application_token={this.props.match.params.application_token}
                                   error_code={this.props.match.params.error_code}
                />;
        }
    }

    render() {
        const { error, awaiting_appl_status, appl_confirmed } = this.state;
        if (error !== null) {
            return this.state.error()
        }

        if (this.props.match.params.step === 'waiting' && awaiting_appl_status === false && appl_confirmed === true) {
            return <Redirect push={true} to={this.state.redirect_url}/>
        }

        return (
            <div ref={this.processContainerRef}>
                {this.props.match.params.step === 'waiting' || awaiting_appl_status
                    ? <div className="tab-content frame p-4 p-sm-5 w-100">
                        <Loading/>
                    </div>
                    : ''
                }
                {this.props.match.params.step === 'contacts'
                    ? <Contacts
                        application_token={this.props.match.params.application_token}
                        suggestion={this.state}
                        data={this.getContactData()}
                    />
                    : ''
                }
                {this.props.match.params.step === 'contacts_sec'
                    ? <ContactsSec
                        application_token={this.props.match.params.application_token}
                        suggestion={this.state}
                        data={this.getContactDataSec()}
                    />
                    : ''
                }
                {this.props.match.params.step === 'incomes'
                    ? <Incomes
                        application_token={this.props.match.params.application_token}
                        suggestion={this.state}
                    />
                    : ''
                }
                {this.props.match.params.step === 'income_family'
                    ? <IncomeFamily
                        application_token={this.props.match.params.application_token}
                        suggestion={this.state}
                    />
                    : ''
                }
                {this.props.match.params.step === 'consent'
                    ? <Consent
                        application_token={this.props.match.params.application_token}
                        suggestion={this.state}
                        phone={_.get(this.state.application, 'client.ind.cont.phone', '')}
                        stepsNo={4}
                        step={3}
                        client_type="P"
                        scrollToProcessContainer={this.scrollToProcessContainer}
                    />
                    : ''
                }
                {this.props.match.params.step === 'consent_sec'
                    ? <Consent
                        application_token={this.props.match.params.application_token}
                        suggestion={this.state}
                        stepsNo={3}
                        step={2}
                        client_type="S"
                        scrollToProcessContainer={this.scrollToProcessContainer}
                    />
                    : ''
                }
                {this.props.match.params.step === 'waiting_consent'
                    ? <WaitingConsent
                        application_token={this.props.match.params.application_token}
                        suggestion={this.state}
                        should_repeat={this.state.should_repeat}
                    />
                    : ''
                }
                {this.props.match.params.step === 'choose_terms'
                    ? <ChooseTerms
                        application_token={this.props.match.params.application_token}
                        suggestion={this.state}
                    />
                    : ''
                }
                {this.props.match.params.step === 'choose_eshop_terms'
                    ? <ChooseEshopTerms
                        application_token={this.props.match.params.application_token}
                        suggestion={this.state}
                    />
                    : ''
                }
                {this.props.match.params.step === 'aml'
                    ? <AML
                        application_token={this.props.match.params.application_token}
                        suggestion={this.state}
                    />
                    : ''
                }
                {this.props.match.params.step === 'view_contract'
                    ? <ViewContract
                        application_token={this.props.match.params.application_token}
                        suggestion={this.state}
                        refreshApplData={this.refreshApplData}
                    />
                    : ''
                }
                {this.props.match.params.step === 'sign_contract'
                    ? <SignContract
                        application_token={this.props.match.params.application_token}
                        suggestion={this.state}
                        phone={_.get(this.state.application, 'client.ind.cont.phone', '')}
                    />
                    : ''
                }
                {this.props.match.params.step === 'done' && appl_confirmed && !awaiting_appl_status
                    ? <Done
                        application_token={this.props.match.params.application_token}
                        should_repeat={this.state.should_repeat}
                        suggestion={this.state}
                    />
                    : ''
                }
                {this.props.match.params.step === 'last_known_step'
                    ? <LastKnownStep
                        application_token={this.props.match.params.application_token}
                        suggestion={this.state}
                    />
                    : ''
                }
                {this.props.match.params.step === 'send_spouse_link'
                    ? <SendSpouseLink
                        application_token={this.props.match.params.application_token}
                        suggestion={this.state}
                    />
                    : ''
                }

                {/* Errors */}
                {this.props.match.params.step === 'incomes_error'
                    ? <BadIncomes
                        application_token={this.props.match.params.application_token}
                        suggestion={this.state}
                    />
                    : ''
                }
                {this.props.match.params.step === 'could_not_finance' ? <CouldNotFinance /> : ''}
                {this.props.match.params.step === 'error' ? this.renderErrorPage() : ''}
            </div>);
    }
}

export default withTranslation()(Process);
